/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Maifud API
 * Documentación de los endpoints de la API de Maifud.
 * OpenAPI spec version: 2.0.0
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import type { UserGiftValidation } from ".././models";

import { customInstance } from "../custom-instance";

/**
 * Comprueba si el usuario autenticado es actualmente elegible para recibir una oferta de regalo de retención.
 * @summary Verificar Elegibilidad de Regalo para Usuario
 */
export const apiV2SubscriptionReasonsUserRetrieve = (signal?: AbortSignal) => {
  return customInstance<UserGiftValidation>({
    url: `/api/v2/subscription/reasons/user/`,
    method: "GET",
    signal,
  });
};

export const getApiV2SubscriptionReasonsUserRetrieveQueryKey = () => {
  return [`/api/v2/subscription/reasons/user/`] as const;
};

export const getApiV2SubscriptionReasonsUserRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV2SubscriptionReasonsUserRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof apiV2SubscriptionReasonsUserRetrieve>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiV2SubscriptionReasonsUserRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV2SubscriptionReasonsUserRetrieve>>
  > = ({ signal }) => apiV2SubscriptionReasonsUserRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV2SubscriptionReasonsUserRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ApiV2SubscriptionReasonsUserRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV2SubscriptionReasonsUserRetrieve>>
>;
export type ApiV2SubscriptionReasonsUserRetrieveQueryError = unknown;

export function useApiV2SubscriptionReasonsUserRetrieve<
  TData = Awaited<ReturnType<typeof apiV2SubscriptionReasonsUserRetrieve>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiV2SubscriptionReasonsUserRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiV2SubscriptionReasonsUserRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiV2SubscriptionReasonsUserRetrieve>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useApiV2SubscriptionReasonsUserRetrieve<
  TData = Awaited<ReturnType<typeof apiV2SubscriptionReasonsUserRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiV2SubscriptionReasonsUserRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiV2SubscriptionReasonsUserRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiV2SubscriptionReasonsUserRetrieve>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useApiV2SubscriptionReasonsUserRetrieve<
  TData = Awaited<ReturnType<typeof apiV2SubscriptionReasonsUserRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiV2SubscriptionReasonsUserRetrieve>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Verificar Elegibilidad de Regalo para Usuario
 */

export function useApiV2SubscriptionReasonsUserRetrieve<
  TData = Awaited<ReturnType<typeof apiV2SubscriptionReasonsUserRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiV2SubscriptionReasonsUserRetrieve>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getApiV2SubscriptionReasonsUserRetrieveQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
